'use client';

import { useRouter } from 'next/navigation';
import { FC } from 'react';
import { SelectApp } from 'sailor-ui';

const AppSelector: FC = () => {
  const router = useRouter();

  const handleHomeClick = () => {
    router.push('/');
  };

  return <SelectApp currentApp="theboat_db" onHomeClick={handleHomeClick} />;
};

export { AppSelector };
